import './Approve.png';
import './CC_Logo_Ko.png';
import './cct-tagging-method-image.jpg';
import './cct-tagging-method-image.png';
import './Cold-Creek-Advantage.jpg';
import './ColdCreek_Small_SingleLine_Logo_KO_v5_cropped.png';
import './coldcreek-header-image.jpg';
import './Computer-Webpage.png';
import './cta_background_image.jpg';
import './metis-tagging-method-image.png';
import './mobile-nav-icon.png';
import './next-arrow.png';
import './testimonial-next-arrow-white.png';
import './read-less-btn.png';
import './read-more-btn.png';
import './ColdCreekWhiteLogo.png';



// WEBPACK FOOTER //
// ./assets/images/main.js